import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import {
  getSamplePoint,
  GetSamplePointResponse,
} from '@/services/data-sources/get-sample-point';

interface UseGetSamplePointOptions extends Omit<
  UseQueryOptions<GetSamplePointResponse>,
  'queryKey' | 'queryFn'
> {
  collectionId?: string;
  externalId?: string;
  orgId?: string;
}

export const useGetSamplePoint = (options?: UseGetSamplePointOptions) => {
  const { collectionId, externalId, orgId, ...queryOptions } = options || {};

  return useQuery<GetSamplePointResponse>({
    queryKey: ['collection-point-sample', orgId, collectionId, externalId],
    queryFn: async () => {
      if (!collectionId || !externalId) {
        throw new Error('collectionId and externalId are required');
      }
      return getSamplePoint({ collectionId, externalId });
    },
    enabled: !!collectionId && !!externalId && !!orgId,
    staleTime: 10 * 1000,
    retry: false,
    ...queryOptions,
  });
};
